import Inspector from './inspector';
const { RichText } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { name, text, image } = attributes;
  const staticDefaultImage = 'https://via.placeholder.com/53x53';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className="swiper-slide CardAdvantage">
        <header className="CardAdvantage-head">
          <figure className="CardAdvantage-image">
            <img
              src={image.src || staticDefaultImage}
              class="MainFeatured-news-image"
            />
          </figure>

          <RichText
            tagName="cite"
            className="CardAdvantage-name"
            value={name}
            placeholder="Bit Trainers"
            keepPlaceholderOnFocus
            onChange={(name) => setAttributes({ name })}
          />
        </header>

        <RichText
          tagName="p"
          className="CardAdvantage-info"
          value={text}
          placeholder="Insira um texto aqui..."
          keepPlaceholderOnFocus
          onChange={(text) => setAttributes({ text })}
        />
      </div>
    </>
  );
};

export default Edit;
